const highlightItem = (item, { highlightHit }) => ({
  ...item,
  displayLabel: highlightHit(item.name),
});

const filterSubTypes = (diseases, searchUtils) =>
  diseases.flatMap((disease) =>
    searchUtils.match(disease.name) ? [highlightItem(disease, searchUtils)] : []
  );

export const transformDiseases = ({ diseases, searchUtils }) => {
  const { highlightHit, match } = searchUtils;

  return diseases.reduce((acc, disease) => {
    const { id, href, name, subTypes } = disease;

    const newDisease = {
      ...disease,
      displayName: highlightHit(disease.name),
      displayLabel: highlightHit(disease.name),
      href: !subTypes.length ? href : "",
      subItems: [],
    };

    if (subTypes.length) {
      newDisease.id = `group_${id}`;
      const virtualEntry = { id, name, href };
      const newSubTypes = href ? [virtualEntry, ...subTypes] : subTypes;
      newDisease.subItems = filterSubTypes(newSubTypes, searchUtils);
    }

    if (newDisease.subItems.length || match(name)) {
      acc.push(newDisease);
    }

    return acc;
  }, []);
};

export const transformAgents = ({ agents, searchUtils }) => {
  const { match } = searchUtils;

  return agents.reduce((acc, agent) => {
    if (match(agent.name)) {
      acc.push(highlightItem(agent, searchUtils));
    }
    return acc;
  }, []);
};
